export const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4000"
    : "https://web-production-6f36.up.railway.app";
